import LoginLayout from '@/layouts/LoginLayout'
import { mapActions, mapMutations, mapState } from 'vuex'
import Verify from './../../components/verifition/Verify'
import { resetRouter } from '@/router/createrRouter'
import { sessionLogin } from '@/apis/login'
import { enc } from '@/utils/jsencrypt'

const loginRules = {
  userName:  { rules: [{ required: true, message: '请输入登录用户!' }] },
  password:  { rules: [{ required: true, message: '请输入登录密码!' },{ min: 6, message: '登录密码最少 8 位！' }]},
}

export default {
  name: 'Login',
  components: { LoginLayout, Verify },
  data () {
    return {
      loginRules,
      submiting: false,
      loginForm: this.$form.createForm(this),
      username: '',
      password: '',
    }
  },
  beforeDestroy() {
    document.removeEventListener('keyup', this.handerKeyup)
  },
  async created () {
    document.addEventListener('keyup', this.handerKeyup)
  },
  computed: {
    ...mapState({
      userAuths: state => state.userStore.userAuths,
      userRoutes: state => state.userStore.userRoutes
    })
  },
  methods: {
    ...mapMutations(['setUserInfo', 'setUserAuths', 'setUserRoutes']),
    ...mapActions(['setUserGAR', 'getEnumsData']),

    handleLogin: function () {
      this.loginForm.validateFields(async (err, values) => {
        if (!err) {
          const {username, password} = values
          this.username = username
          this.password = password
          this.$refs.verify.show()
        }
      })
    },
    doLogin: async function (params) {
      this.submiting = true
      try {
        let loginParams = {
          loginNameEnc: enc(this.username),
          loginType: 1,
          passwordEnc: enc(this.password),
          captchaVO: {
            captchaType: "blockPuzzle",
            captchaVerification: params.captchaVerification,
          }
        }
        const { data: userInfo } = await sessionLogin(loginParams)
        // Vuex 保存登录用户信息
        this.setUserInfo(userInfo)
        // Vuex 设置登录用户的页面路由，不传参时，会重新调用一次 createRoutes
        this.setUserRoutes()
        // 重置路由
        resetRouter(this.$router, this.userRoutes)
        // 获取并设置系统枚举数据
        await this.getEnumsData()
        this.$message.success('登录成功！')
        await this.$router.push('/')
      } catch (error) {
        this.$message.error(error)
      }
      this.submiting = false
    },
  }
}
